









































import {Component, Inject, Vue, Watch} from "vue-property-decorator";
  import {mapGetters} from "vuex";
  import {orderBy} from "lodash";
  import Game from "@/model/Game";
  import {GameMood, PlayerGlobalData} from "@/model/Player";
  import {DataService} from "@/services/DataService";

  @Component({
  computed: {
    ...mapGetters({
      games: "games"
    })
  }
})
export default class Players extends Vue {
  @Inject("dataService") public dataService!: DataService;
  protected games!: Game[];
  private dataForPlayers: PlayerGlobalData[] = [];
  private sortKey: string = "playerRef.playerName";
  private sortKeyDirection: string = "asc";

  public created() {
    this.loadData();
  }

  @Watch("games")
  public loadData() {
    this.dataForPlayers = this.dataService.computePlayersPerformance(this.games);
    this.dataForPlayers = orderBy(this.dataForPlayers, ["playerRef.playerName"], ["asc"]);
  }

  public changeSort(key: string) {
    if (this.sortKey === key) {
      this.sortKeyDirection = this.sortKeyDirection === "desc" ? "asc" : "desc";
    } else {
      this.sortKeyDirection = "desc";
    }
    this.sortKey = key;
  }

  get sortedDataForPlayers(): PlayerGlobalData[] {
    // @ts-ignore
    return orderBy(this.dataForPlayers, [this.sortKey], this.sortKeyDirection);
  }

  public goToGame(mood: GameMood) {
    this.$router.push(`game/${mood.mapRef}`);
  }
}
